import { render, staticRenderFns } from "./top-api-table.vue?vue&type=template&id=298dcb38&scoped=true"
import script from "./top-api-table.vue?vue&type=script&lang=ts"
export * from "./top-api-table.vue?vue&type=script&lang=ts"
import style0 from "./top-api-table.vue?vue&type=style&index=0&id=298dcb38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298dcb38",
  null
  
)

export default component.exports